import { Component } from "@angular/core";

@Component({
    selector: 'header-layout',
    templateUrl: './header-layout.component.html',
    styleUrls: ['./header-layout.component.css']
})
export class HeaderLayoutComponent {

}